import { WarningIcon, Typography } from "@packages/ds";
import styled from "styled-components";

export const CustomDomainsText = styled(Typography.BodyText)`
  margin-left: 18px;
`;

export const Warning = styled(WarningIcon)`
  fill: var(--icon-gold-fill, var(--gold));
`;

export const WarningContainer = styled.div`
  margin-top: 16px;
  display: flex;
  flex-direction: row;
`;
